import { render, staticRenderFns } from "./InspectionsCard.vue?vue&type=template&id=d8a64502"
import script from "./InspectionsCard.vue?vue&type=script&lang=js"
export * from "./InspectionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports